// removed by extract-text-webpack-plugin
module.exports = {"vpButtonContainer":"vpButtonContainer___iXqiu","hideUploadButtons":"hideUploadButtons___3muD-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/UploadOrRecordSelector.module.less
// module id = 3461
// module chunks = 31